import React from "react";
import { Route } from "react-router-dom";
import FarmerHomepage from "../../screens/farmer/FarmerHomepage";
import FarmerProfileMain from "../../screens/farmer/FarmerProfileMain";
import Farms from "../../screens/farmer/Farms";
import ViewFarm from "../../screens/farmer/ViewFarm";
import ViewFarmSatelliteData from "../../screens/farmer/ViewFarmSatelliteData";
import WalletScreen from "../../screens/WalletScreen";
import Crops from "../../screens/farmer/Crops";
import ViewCropDetails from "../../screens/farmer/ViewCropDetails";
import PesticideFertilizers from "../../screens/farmer/PesticideFertilizers";
import CreatePesticideFertilizer from "../../screens/farmer/CreatePesticideFertilizer";
import LabTests from "../../screens/farmer/LabTests";
import LabTestView from "../../screens/farmer/LabTestView";
import CreateLabTest from "../../screens/farmer/CreateLabTest";
import Harvests from "../../screens/farmer/Harvests";
import Advisory from "../../screens/farmer/Advisory";
import CreateHarvestNew from "../../screens/farmer/CreateHarvestNew";
import ViewHarvestNew from "../../screens/farmer/ViewHarvestNew";
import CreateHarvestSale from "../../screens/farmer/CreateHarvestSale";
import FarmerProfile from "../../screens/farmer/FarmerProfile";
import PersonalInformation from "../../screens/farmer/PersonalInformation";
import Decarbonization from "../../screens/farmer/Decarbonization";
import DecarbonizationPrograms from "../../screens/farmer/DecarbonizationPrograms";
import ProgramInput from "../../screens/farmer/ProgramInput";
import ServiceProviders from "../../screens/farmer/ServiceProviders";
import Warehouses from "../../screens/farmer/Warehouses";
import Tutorials from "../../screens/farmer/Tutorials";
import CreateSoilTest from "../../screens/farmer/CreateSoilTest";
import SoilTestLabs from "../../screens/farmer/SoilTestLabs";
import CreateFarmSubscription from "../../screens/subscription/CreateFarmSubscription";
import CreateFarm from "../../screens/land/CreateFarm";
import CreateCrop from "../../screens/land/CreateCrop";
import KYC from "../../screens/farmer/Kyc";
import CreateAdvisoryQuestion from "../../screens/advisory/CreateAdvisoryQuestion";
import ViewAdvisoryQuestion from "../../screens/advisory/ViewAdvisoryQuestion";
import Claims from "../../screens/Claims";
import CreateClaim from "../../screens/supply_chain/CreateClaim";
import TaskDetails from "../../screens/farmer/TaskProgramDetails";
import ProgramTaskStatusUpdate from "../../screens/programs/ProgramTaskStatusUpdate";
import MarketPrices from "../../screens/market_prices/MarketPrices";
import NutritionDeficiencyDetection from "../../screens/advisory/NutritionDeficiencyDetection";
import Activity from "../../screens/plot_engagement/Activity";
import ScheduleActivity from "../../screens/plot_engagement/ScheduleActivity";
import SatelliteDataReportsListing from "../../screens/farmer/satellite_data_report/SatelliteDataReportsListing";
import UserBiocharOrders from "../../screens/UserBiocharOrders";
// import RequestBiochar from "../../screens/farmer/RequestBiochar";
import ProcurementList from "../../screens/biochar/ProcurementList";
import ProcurementForm from "../../screens/biochar/ProcurementForm";
import ProcurementDetail from "../../screens/biochar/ProcurementDetail";
import ProcurementPickupRequest from "../../screens/biochar/ProcurementPickupRequest";
import BiocharLandingScreen from "../../screens/farmer/BiocharLandingScreen";
import RequestBiochar from "../../screens/biochar/RequestBiochar";
import DehaatLogin from "../../screens/farmer/DehaatLogin";
import CropTraceActivities from "../../screens/farmer/CropTraceActivities";
import Program from "../../screens/farmer/program/Program";
import ProgramSignup from "../../screens/farmer/program/ProgramSignup";
import ProgramDetail from "../../screens/farmer/program/ProgramDetail";

export const farmerRoutes = [
  <Route key="home" path="/" element={<FarmerHomepage />} />,
  <Route
    key="service-farmer"
    path="/service/farmer"
    element={<FarmerProfileMain />}
  />,
  <Route key="farmer-farms" path="/farmer/farms" element={<Farms />} />,
  <Route
    key="farmer-create-farm"
    path="/farmer/create-farm"
    element={<CreateFarm />}
  />,
  <Route
    key="farmer-farm-detail"
    path="/farmer/farm/:farmId"
    element={<ViewFarm />}
  />,
  <Route
    key="farmer-satellite-data"
    path="/farmer/satellite-data-farm/:farmId"
    element={<ViewFarmSatelliteData />}
  />,
  <Route
    key="farms"
    path="/farms"
    element={<WalletScreen walletType="FARMLAND" />}
  />,
  <Route
    key="create-farmland"
    path="/create-farmland"
    element={<CreateFarm />}
  />,
  <Route key="farmer-crops" path="/farmer/crops" element={<Crops />} />,
  <Route
    key="farmer-crop-detail"
    path="/farmer/crop/:cropId"
    element={<ViewCropDetails />}
  />,
  <Route
    key="farmer-pesticide-fertilizers"
    path="/farmer/persicide-fertilizers"
    element={<PesticideFertilizers />}
  />,
  <Route
    key="farmer-create-pesticide"
    path="/farmer/create-persicide-fertilizers"
    element={<CreatePesticideFertilizer />}
  />,
  <Route
    key="farmer-lab-tests"
    path="/farmer/lab-tests"
    element={<LabTests />}
  />,
  <Route
    key="farmer-lab-test-detail"
    path="/farmer/lab-test/:labId"
    element={<LabTestView />}
  />,
  <Route
    key="farmer-create-lab-test"
    path="/farmer/create-lab-test"
    element={<CreateLabTest />}
  />,
  <Route
    key="farmer-crops-create"
    path="/farmer/crops/create"
    element={<CreateCrop />}
  />,
  <Route
    key="crops"
    path="/crops"
    element={<WalletScreen walletType="CROP" />}
  />,
  <Route key="create-crop" path="/create-crop" element={<CreateCrop />} />,
  <Route
    key="farmer-harvests"
    path="/farmer/harvests"
    element={<Harvests />}
  />,
  <Route
    key="farmer-crop-health"
    path="/farmer/crop-health"
    element={<Advisory />}
  />,
  <Route
    key="farmer-create-harvest"
    path="/farmer/create-harvest"
    element={<CreateHarvestNew />}
  />,
  <Route
    key="farmer-harvest-detail"
    path="/farmer/harvest/:harvestId"
    element={<ViewHarvestNew />}
  />,
  <Route
    key="farmer-harvest-sales-add"
    path="/farmer/harvest-sales-add/:harvestId"
    element={<CreateHarvestSale />}
  />,
  <Route
    key="farmer-profile"
    path="/farmer/profile"
    element={<FarmerProfile />}
  />,
  <Route
    key="farmer-profile-personal"
    path="/farmer/profile/personal"
    element={<PersonalInformation />}
  />,
  <Route
    key="farmer-profile-kyc"
    path="/farmer/profile/kyc"
    element={<KYC />}
  />,
  <Route
    key="advisory-create-question"
    path="/advisory/create-question"
    element={<CreateAdvisoryQuestion />}
  />,
  <Route
    key="advisory-question-detail"
    path="/advisory/question/:questionId"
    element={<ViewAdvisoryQuestion />}
  />,
  <Route key="claims" path="/claims" element={<Claims />} />,
  <Route key="create-claim" path="/create-claim" element={<CreateClaim />} />,
  <Route
    key="decarbonization"
    path="/decarbonization"
    element={<Decarbonization />}
  />,
  <Route
    key="decarbonization-program-list"
    path="/decarbonization/program-list"
    element={<DecarbonizationPrograms />}
  />,
  <Route
    key="decarbonization-stubble-management"
    path="/decarbonization/stubble-management"
    element={<Decarbonization />}
  />,
  <Route
    key="farmer-program-input"
    path="/farmer/program-input"
    element={<ProgramInput />}
  />,
  <Route key="farmer-programs" path="/farmer/programs" element={<Program />} />,
  <Route
    key="farmer-program-signup"
    path="/farmer/programs/signup/:cropId"
    element={<ProgramSignup />}
  />,
  <Route
    key="farmer-program-detail"
    path="/farmer/programs/:programId"
    element={<ProgramDetail />}
  />,
  <Route
    key="farmer-program-task-details"
    path="/farmer/program-task-details/:taskId"
    element={<TaskDetails />}
  />,
  <Route
    key="farmer-program-task-status-update"
    path="/farmer/program-task-status-update/:taskId"
    element={<ProgramTaskStatusUpdate />}
  />,

  <Route
    key="farmer-market-rate"
    path="/farmer/market-rate"
    element={<MarketPrices />}
  />,
  <Route
    key="farmer-advisory"
    path="/farmer/advisory"
    element={<Advisory />}
  />,
  <Route
    key="farmer-service-providers"
    path="/farmer/service-providers"
    element={<ServiceProviders />}
  />,
  <Route
    key="farmer-warehouses"
    path="/farmer/warehouses"
    element={<Warehouses />}
  />,
  <Route
    key="farmer-tutorials"
    path="/farmer/tutorials"
    element={<Tutorials />}
  />,
  <Route
    key="farmer-soil-testing-create"
    path="/farmer/soil-testing/create"
    element={<CreateSoilTest />}
  />,
  <Route
    key="farmer-nutrition-deficiency"
    path="/farmer/nutrition-deficiency-detection"
    element={<NutritionDeficiencyDetection />}
  />,
  <Route
    key="farmer-soil-testing-labs"
    path="/farmer/soil-testing-labs"
    element={<SoilTestLabs />}
  />,
  <Route key="activity-detail" path="/activity/:id" element={<Activity />} />,
  <Route
    key="schedule-activity"
    path="/schedule-activity/:farmerPlotId"
    element={<ScheduleActivity />}
  />,
  <Route
    key="farmer-satellite-data-report"
    path="/farmer/satellite-data-report-dates"
    element={<SatelliteDataReportsListing />}
  />,
  <Route
    key="farm-subscribe"
    path="/farm-subscribe/:farmId"
    element={<CreateFarmSubscription />}
  />,
  <Route key="biochar" path="/biochar" element={<BiocharLandingScreen />} />,
  <Route
    key="biochar-orders"
    path="/biochar-orders"
    element={<UserBiocharOrders />}
  />,
  // <Route path="/request-biochar" element={<RequestBiochar />} />,
  <Route
    key="procurement-list"
    path="/procurement-list"
    element={<ProcurementList />}
  />,
  <Route
    key="procurement-form"
    path="/procurement-form"
    element={<ProcurementForm />}
  />,
  <Route
    key="procurement-detail"
    path="/procurement/:id"
    element={<ProcurementDetail />}
  />,
  <Route
    key="procurement-pickup-request"
    path="/procurement/pickup-request/:id"
    element={<ProcurementPickupRequest />}
  />,
  <Route
    key="request-biochar"
    path="/request-biochar"
    element={<RequestBiochar />}
  />,
  <Route key="farmer-dehaat" path="/farmer/dehaat" element={<DehaatLogin />} />,
  <Route
    key="farmer-crop-trace-activities"
    path="/farmer/crop-trace-activities"
    element={<CropTraceActivities />}
  />,
];
